import EntityModel from '@/common/models/entity-model';

export default class CreditMemoAllocationItemModel extends EntityModel {
    hydrate({
        invoiceItemId = null,
        totalCredit = null,
        taxCredit = null,
    } = {}) {
        this.invoiceItemId = invoiceItemId;
        this.totalCredit = totalCredit;
        this.taxCredit = taxCredit;
    }
}
